import { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { db } from "../firebase";
import { capitalizeFirstLetter } from "./services";

const Button = ({ children }) => {
  return (
    <button className="w-max max-w-full hover:bg-darkblue  bg-blue text-white py-2 px-8 text-lg">
      {children}
    </button>
  );
};
const Badge = ({ children, className }) => {
  return (
    <span
      className={`${
        className ? className : ""
      } w-max max-w-full text-white  px-4 py-2 text-lg`}
    >
      {children}
    </span>
  );
};
const ORDER = () => {
  const params = useParams();
  const [currentItem, setCurrentItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setLoading(true)
    db.collection("websites")
      .doc(params.id)
      .get()
      .then((doc) => {
        setCurrentItem(doc.data());
        setLoading(false)
        console.log(doc.data());
      })
      .catch((err) => {
      setLoading(false)

        alert(
          "Something happened while fetching data. If this happens continuesly please contact us. Redirecting..."
        );
        history.push("/");
      });
  }, [params.id]);
  const cardStyle = {
    backgroundImage: `url(${currentItem ? currentItem.cover : ""})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
  return (
    <div className="flex flex-col w-full overflow-y-auto h-full py-12">
      {currentItem && (
        <div className="flex flex-col w-full">
          <div style={cardStyle} className="w-full relative h-72 flex-shrink-0">
            {!currentItem.sold && !currentItem.payment_pending && (
              <Badge className="bg-green font-bold hover absolute bottom-2 right-2">
                New
              </Badge>
            )}
            {currentItem.sold && !currentItem.payment_pending && (
              <Badge className="bg-red font-bold hover absolute bottom-2 right-2">
                Sold Out
              </Badge>
            )}
            {!currentItem.sold && currentItem.payment_pending && (
              <Badge className="bg-gray  font-bold hover absolute bottom-2 right-2">
                Order Pending
              </Badge>
            )}
          </div>
          <div className="my-8  flex justify-between">
            <div className="text-2xl sm:text-3xl w-full">
              {currentItem ? capitalizeFirstLetter(currentItem.title) : "Loading..."}
            </div>
            <div className="text-3xl sm:text-4xl font-bold w-max flex-shrink-0">
              {currentItem ? currentItem.price : "Loading..."}$
            </div>
          </div>
          {!currentItem.sold && (
            <div className="flex items-center gap-6 flex-wrap">
              {!currentItem.payment_pending && (
                <Link to={`/order/${currentItem.id}`}>
                  <Button>Order</Button>
                </Link>
              )}
              <a target="_blank" rel="noreferrer" href={currentItem.link}>
                <Button>Preview</Button>
              </a>
            </div>
          )}
          <div className="mt-8 w-full text-lg">A {currentItem.type} page with {currentItem.pages===1 ? 'one page' : `${currentItem.pages} pages`}</div>
          <div className="mt-8 w-full text-lg">{currentItem.description}</div>
          <div className="mt-8 w-full flex flex-col text-lg">
            <div className="mb-4 w-full text-lg">Colors used</div>
            <div className="flex items-center gap-4">
              {currentItem.colors.map((color) => (
                <div
                  style={{ backgroundColor: color }}
                  className="w-10 h-10 rounded-full border border-2"
                  key={color}
                ></div>
              ))}
            </div>
          </div>
        </div>
      )}
      {loading && <p className="text-base w-full italic mt-4">Loading...</p>}

    </div>
  );
};

export default ORDER;
